const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  menus: state => state.user.menus,

  currentDate: state => state.app.currentDate, // CX2018当前账期（属期）
  selectedClient: state => state.app.selectedClient, // 当前选择的客户
  selectedConsult: state => state.app.selectedConsult,   // 当前选择的咨询记录
  selectedShared: state => state.app.selectedShared,   // 当前选择的资源共享
  selectedInvoice: state => state.app.selectedInvoice,   // 当前选择的客户开票记录
  selectedTransfer: state => state.app.selectedTransfer, // 当前选择的客户转账记录

  tips: state => state.tip.tips, // 消息提示列表

  mName: state => state.app.mName 

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js